module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/pageBannerMedium-3cf22605662f432e87ac952c129f7ee5.png";